import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type State = {
  sessionId: string | null;
  openItems: { [id: string]: boolean };
};

type Actions = {
  toggleOpenItem: (id: string) => void;
  openAll: () => void;
  closeAll: () => void;
  setSessionId: (sessionId: string | null) => void;
};

const persistMiddleware = persist<State & Actions>(
  (set, get) => {
    return {
      sessionId: null,
      openItems: {},
      toggleOpenItem: id => {
        set({ openItems: { ...get().openItems, [id]: !get().openItems?.[id] } });
      },
      openAll: () => {
        set({
          openItems: Object.keys(get().openItems).reduce(
            (acc, curr) => ({ ...acc, [curr]: true }),
            {},
          ),
        });
      },
      closeAll: () => {
        set({
          openItems: Object.keys(get().openItems).reduce(
            (acc, curr) => ({ ...acc, [curr]: false }),
            {},
          ),
        });
      },
      setSessionId: sessionId => {
        set({ sessionId });
      },
    };
  },
  {
    name: 'sidebar',
    storage: createJSONStorage(() => localStorage),
  },
);

export const useSidebarShowSubItems = create(persistMiddleware);
